import { jsPDF } from "jspdf";
// import { addHeaderAndFooter } from "./addHeaderAndFooter";
import { addPics } from "./addPics";
import { addPage } from "./addPage";
import { setFont } from "./setFont";
// import { addContacts } from "./addContacts";
// import { addComments } from "./addComments";
// import { addTextLine } from "./addTextLine";
// import { addStatusChanges } from "./addStatusChanges";
import { addFormattedText } from "./addFormattedText";
import obsDoc from "./obsDoc";
// import moment from "moment";
import calibri from "../../fonts/Calibri.ttf";
import calibrib from "../../fonts/calibrib.ttf";
import calibrii from "../../fonts/calibrii.ttf";
import calibriz from "../../fonts/calibriz.ttf";
import { applyHeaderAndFooter } from "./applyHeaderAndFooter";

export async function exportObservation(project, observation_id, template) {
  const doc = new jsPDF({
    orientation: "p",
    unit: "in",
    format: "letter",
    compress: true,
  });

  // console.log(doc.internal.pageSize);
  const pageHeight = doc.internal.pageSize.height - 1; // Get page height minus some

  const observation =
    project.Observations.find((i) => i.id === observation_id) || null;
  // const issues =
  //   project.Issues.filter((i) => i.observation_id === observation_id) || null;
  var cursorY = 1.5; //initial cursor position

  //Add custom font
  doc.addFont(calibri, "calibri", "normal");
  doc.addFont(calibrib, "calibri", "bold");
  doc.addFont(calibrii, "calibri", "italic");
  doc.addFont(calibriz, "calibri", "bold_italic");

  setFont(doc, false);
  //Header & footer logo
  // await addHeaderAndFooter(doc);
  setFont(doc, true);

  for (let z = 0; z < template.length; z++) {
    //addPage if at bottom of page
    if (cursorY + 1 > pageHeight) {
      cursorY = await addPage(doc, cursorY);
    }

    const section = template[z];
    //section header
    setFont(doc, true);
    if (section.name !== "Issue Comments") {
      doc.text(
        // section.name === "Issues"
        //   ? `Issue No ${issues[z].No}`
        //   :
        section.name === "Observation"
          ? `Observation No ${observation.No}`
          : // : section.name === "Issue"
            //   ? `Issue No ${issue.No}`
            section.name === "Project"
            ? `Project: ${project.Name}`
            : section.name,
        doc.internal.pageSize.width / 2,
        cursorY,
        {
          align: "center",
        },
      );
    }

    const objArry =
      section.name === "Project"
        ? [project]
        : section.name === "Contacts"
          ? project.Contacts
          : section.name === "Observation"
            ? [observation]
            : section.name === "Issues"
              ? project["Issues"].filter(
                  (c) => c.observation_id === observation_id,
                )
              : section.name === "Issue Comments"
                ? []
                : section.name === "Observation Comments"
                  ? project["Comments"].filter(
                      (c) => c.observation_id === observation_id,
                    )
                  : [];

    cursorY += obsDoc.lineSpacing * 2;

    for (let y = 0; y < objArry.length; y++) {
      const secObj = objArry[y];
      for (let i = 0; i < section.fields.length; i++) {
        const fd = section.fields[i];
        console.log(section.name);
        if (fd.name === "Show Pictures?" && fd.checked) {
          //Pics
          cursorY = await addPics(
            doc,
            section.name === "Issues"
              ? project.Files.filter(
                  (f) =>
                    (f.issue_id === secObj.id &&
                      f.name.toLowerCase().endsWith(".jpg")) ||
                    (f.issue_id === secObj.id &&
                      f.name.toLowerCase().endsWith(".png")) ||
                    (f.issue_id === secObj.id &&
                      f.name.toLowerCase().endsWith(".jpeg")),
                )
              : section.name.toLowerCase().includes("comment")
                ? project.Files.filter(
                    (f) =>
                      (f.comment_id === secObj.id &&
                        f.name.toLowerCase().endsWith(".jpg")) ||
                      (f.comment_id === secObj.id &&
                        f.name.toLowerCase().endsWith(".png")) ||
                      (f.comment_id === secObj.id &&
                        f.name.toLowerCase().endsWith(".jpeg")),
                  )
                : section.name.toLowerCase().includes("observation")
                  ? project.Files.filter(
                      (f) =>
                        (f.observation_id === secObj.id &&
                          f.name.toLowerCase().endsWith(".jpg")) ||
                        (f.observation_id === secObj.id &&
                          f.name.toLowerCase().endsWith(".png")) ||
                        (f.observation_id === secObj.id &&
                          f.name.toLowerCase().endsWith(".jpeg")),
                    )
                  : [],
            cursorY,
          );
        } else if (fd.checked) {
          //Field label
          setFont(doc, true);
          doc.text(fd.name + ":", obsDoc.xPosition, cursorY);
          cursorY += obsDoc.lineSpacing;
          setFont(doc, false);
          //Field text
          cursorY = await addFormattedText(
            doc,
            cursorY,
            typeof secObj[fd.name] === "object" &&
              secObj[fd.name].hasOwnProperty("seconds")
              ? new Date(secObj[fd.name].seconds * 1000).toLocaleDateString()
              : secObj[fd.name],
          );
        }
      }

      //Issue comments
      if (section.name === "Issues") {
        console.log(secObj);
        console.log(secObj.id);
        const issueComments = project["Comments"].filter(
          (c) => c.issue_id === secObj.id,
        );
        if (issueComments.length > 0) {
          //move cursor down between sections
          cursorY += obsDoc.lineSpacing;
          setFont(doc, true);
          doc.text(
            `Issue No ${secObj.No} Comments`,
            doc.internal.pageSize.width / 2,
            cursorY,
          );
          cursorY += obsDoc.lineSpacing;
        }

        const templateSection = template.find(
          (s) => s.name === "Issue Comments",
        );
        for (let j = 0; j < issueComments.length; j++) {
          const com = issueComments[j];
          for (let k = 0; k < templateSection.fields.length; k++) {
            if (
              templateSection.fields[k].name === "Show Pictures?" &&
              templateSection.fields[k].checked
            ) {
              cursorY = await addPics(
                doc,
                project.Files.filter(
                  (f) =>
                    (f.comment_id === com.id &&
                      f.name.toLowerCase().endsWith(".jpg")) ||
                    (f.comment_id === com.id &&
                      f.name.toLowerCase().endsWith(".png")) ||
                    (f.comment_id === com.id &&
                      f.name.toLowerCase().endsWith(".jpeg")),
                ),
                cursorY,
              );
            } else if (templateSection.fields[k].checked) {
              //Field label
              setFont(doc, true);
              doc.text(
                templateSection.fields[k].name + ":",
                obsDoc.xPosition,
                cursorY,
              );
              cursorY += obsDoc.lineSpacing;
              setFont(doc, false);
              //Field text
              cursorY = await addFormattedText(
                doc,
                cursorY,
                typeof com[templateSection.fields[k].name] === "object" &&
                  com[templateSection.fields[k].name].hasOwnProperty("seconds")
                  ? new Date(
                      com[templateSection.fields[k].name].seconds * 1000,
                    ).toLocaleDateString()
                  : com[templateSection.fields[k].name],
              );
            }
          }

          cursorY += obsDoc.lineSpacing;
        }
      }

      //move cursor down between sections
      cursorY += obsDoc.lineSpacing * 2;
    }
  }

  //     //issue pics header
  //     if (issues[i].pics.length > 0) {
  //       cursorY += obsDoc.lineSpacing;
  //       setFont(doc, true);
  //       cursorY = await addTextLine(doc, cursorY, "Issue Photos:");
  //       setFont(doc, false);

  //       //issue Pics
  //       cursorY = await addPics(doc, issues[i].pics, cursorY);
  //     }

  //     cursorY += obsDoc.lineSpacing;

  // will save the file in the current working directory

  await applyHeaderAndFooter(doc, 0, project.uid);

  return await doc.save(
    project.Name.replace(/[/\\?%*:|"<>]/g, "-") +
      `_Observation_No_${observation.No}.pdf`,
    { returnPromise: true },
  );
}
